import fetch from "../utils/fetch";

/**
 * instagram用户登录
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Authentication_POST
 * @param username 用户名
 * @param password 密码
 * @returns {*}
 */
export function login({ username, password }) {
  return fetch.post("publishers/self", {
    username,
    password,
  });
}

/**
 * 发送验证码到用户指定的接收方式 email/phone。
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Validation_send_security_code
 * @param form 表单信息
 * @returns {*}
 */
export function checkpoint({ form }) {
  return fetch.post("publishers/checkpoint", form);
}

/**
 * 提交验证码到服务器
 * http://schedulepost.dev.apphi.com/api/docs/#!/publishers/Publisher_Validation_validate_security_code
 * @param form 表单信息
 * @returns {*}
 */
export function validation({ form }) {
  return fetch.post("publishers/validation", form);
}



// WEBPACK FOOTER //
// ./src/apis/publisher.js